import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import { InitUploadRequest, InitUploadResponse } from '@/lib/upload/types.ts';
import { TemplateImageDto } from '@/features/dashboard/templateImages/types/TemplateImageDto.ts';

const templateImagesApi = {
  initUpload: async (
    request: InitUploadRequest,
  ): Promise<InitUploadResponse> => {
    return await fetchPrivateApi<InitUploadResponse>(
      'POST',
      `template-images/init-upload`,
      request,
    );
  },
  confirmUpload: async (fileId: string): Promise<void> => {
    return await fetchPrivateApi<void>(
      'POST',
      `template-images/${fileId}/confirm-upload`,
    );
  },
  list: async (): Promise<TemplateImageDto[]> => {
    return await fetchPrivateApi<TemplateImageDto[]>('GET', `template-images`);
  },
  getDownloadUrl: async (fileId: string): Promise<string> => {
    return await fetchPrivateApi<string>(
      'GET',
      `template-images/${fileId}/download-url`,
    );
  },
  remove: async (fileId: string): Promise<void> => {
    return await fetchPrivateApi<void>('DELETE', `template-images/${fileId}`);
  },
};

export default templateImagesApi;
